<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="日志查询"> </pageTitle>
    <div style="height: 20px"></div>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @cellClick="cellClick"
    >
      <template v-slot:operation="row">
        <div style="display: none; align-items: center"></div>
      </template>
    </basicList>
  </div>
</template>

<script>
import { getRoles } from "@/utils";
import { logGetlist, getshoplist } from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "onlineBanking",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      compId: 0,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺
      // 列表组件参数
      basicListconfig: {
        operation: false,
        loading: false,
        data: [],
        search: [
          {
            label: "操作人/品名/条码/内容",
            type: "input",
            key: "keywords",
          },
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
        ],
        column: [
          {
            label: "ID",
            prop: "id",
            width: 100,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 150,
          },
          {
            label: "操作人",
            prop: "real_name",
            width: 120,
          },
          {
            label: "内容",
            prop: "body",
            width: 500,
          },
          {
            label: "创建时间",
            prop: "create_time",
            width: 150,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
  },
  methods: {
    copyAddress(text) {
      let oInput = document.createElement("input");
      //这边为链接地址this.liveLink='www.baidu.com'
      oInput.value = text;
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    cellClick(row, column, cell, event) {
      if (column.property == "body") {
        this.copyAddress(row.body);
      }
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        
      }
      this.getlist();
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id =
        this.$store.getters.userInfo.compId;
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }

      let data = {
        shop_id: this.basicListconfig.searchParameters["shop_id"],
        comp_id: JSON.parse(getRoles()).comp_id,
        begin_at: this.$getCurrent(1),
      };

      getshoplist({
        
        ...{ status: 0, comp_id: JSON.parse(getRoles()).comp_id },
      }).then((res) => {
        if (res.code == 1) {
          this.shopIds = res.data.map((item) => item.id);
          this.basicListconfig.search.map((item) => {
            if (item.key == "shop_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      this.basicListconfig.searchParameters.is_showAll = 1;
      logGetlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/employeeLog/index.vue